module.exports = __webpack_public_path__ + "static/media/Wendell L. Willkie - 1940.fc6c8e43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Wendell L. Willkie - 1940.jpg
// module id = 563
// module chunks = 0